import { render, staticRenderFns } from "./MineListCardItem.vue?vue&type=template&id=2a2c8b41&scoped=true"
import script from "./MineListCardItem.vue?vue&type=script&lang=js"
export * from "./MineListCardItem.vue?vue&type=script&lang=js"
import style0 from "./MineListCardItem.vue?vue&type=style&index=0&id=2a2c8b41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2c8b41",
  null
  
)

export default component.exports